import { DestroyRef } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { Flight } from "../../models/flight.model";
import { coPilotWithRole, pilotsControls, watchCoPilot } from "../tabs/crew/pilots-group/pilots-group";
import { passengersControls } from "../tabs/crew/passengers-group/passengers-group";
import { engineControls } from "../tabs/engine-data/engine-data";
import { flightControls } from "../tabs/flight/flight-group/flight-group";
import { legControls, watchGroundRunLeg } from "../tabs/flight/leg-group/leg-group";
import { forwardTimes, timesControls } from "../tabs/flight/times-group/times-group";
import { FlightEditLookups } from "./flight-edit-lookups";

export function buildFlightGroup(flight: Flight, lookups: FlightEditLookups, destroyRef: DestroyRef) {
    const group = new FormGroup(
        {
            ...flightControls(flight, lookups),
            ...legControls(flight, lookups),
            ...timesControls(flight, lookups),
            ...pilotsControls(flight, lookups),
            ...passengersControls(flight),
            ...engineControls(flight),
        },
        { validators: [forwardTimes, coPilotWithRole] },
    );
    watchCoPilot(group.controls.coPilot, group.controls.coPilotRoleId, destroyRef);
    if (lookups.isGroundRun(flight)) watchGroundRunLeg(group.controls.departureId, group.controls.arrivalId, destroyRef);
    return group;
}

export type FlightGroup = ReturnType<typeof buildFlightGroup>;
